export interface AuthenticationResponseModel {
  accessToken: string;
  refreshToken: string;
}

export interface DsCredentialsRequestBody {
  UserName: string;
  Password: string;
  TwoFactorCode?: string;
}

export interface DsCredentialsResponseBody {
  Token: string;
  KeysInfo: DsKeyInfo[];
}

export interface DsKeyInfo {
  KeyName: string;
  CertificatesInformation: DsCertificateInformation[];
}

export interface DsCertificateInformation {
  ExpireDate: string;
  StartDate: string;
  KeyUsage: string;
  Thumbprint: string;
  Edrpou: string;
  Drfo: string;
  FullName: string;
  OrgUnit: string;
  Org: string;
  Address: string;
  Phone: string;
  EMail: string;
  SubjectTitle: string;
  Issuer: string;
  IssuerCN: string;
  Serial: string;
  ExtKeyUsage: string;
  Upn: string;
  PowerCert: boolean;
  QSCD: boolean;
  CommonName: string;
}

export interface DsKeyValidationRequestBody {
  KeyName: string;
  Password: string;
  TwoFactorCode?: string;
}

export interface DsKeyValidationResponseBody {
  IsValid: boolean;
}

export interface DsHashRequestBody {
  login: string;
}

export interface DsSignResponseBody {
  SignedHash: string;
}

export interface DsSignRequestBody {
  Password: string;
  FileHash: string;
  KeyName: string;
  TwoFactorCode?: string;
}

export interface LiloLoginWithHash {
  login: string;
  signedHash: string;
}
